window.c21Helpers = (function() {
   return {
      GS : ',',
      GS2 : '|',
      NULL : unescape('%18'),

      queryToJSON : function(strQueryString) {
         var result = {},
            list = strQueryString.split('&');

         $.each(list, function(i, strItem) {
             var row = strItem.split('=');

             if (row.length == 2) {
                 result[row[0]] = unescape(row[1]).replace(/\+/g, " ");
             }
         });

         return result;
      },

      nullSafeStrEquals : function(lhs, rhs) {
         if (lhs == null || lhs.length == 0) {
             lhs = null;
         }

         if (rhs == null || rhs.length == 0) {
             rhs = null;
         }

         return rhs == lhs;
      },

      stopEvent : function(event) {
         if (!event) {
             var event = window.event;
         }
         if (event) {
            event.cancelBubble = true;
         }
         
         if (event && event.stopPropagation) {
            event.stopPropagation();
         }

         return false;
      }
   };
}());
